import angular from 'angular';
import { PayoutReportCommonModule } from './common/payout-report-common.module';
import { PayoutReportContainerModule } from './container/payout-report-container.module';
import { PayoutReportRogersModule } from './rogers/payout-report-rogers.module';

/**
 * A module that exposes all common, container-level, and division-specific modules
 * for displaying payout reports.
 */
export const PayoutReportModule = angular
    .module("apex.mainApp.payout.report", [
        PayoutReportCommonModule,
        PayoutReportContainerModule,
        PayoutReportRogersModule
    ])
    .name;
